"use client";
import React, { Component } from "react";
import * as yup from "yup";
import {
  Modal,
  Divider,
  Segment,
  Icon,
  Grid,
  Form,
  Button,
  Message,
} from "semantic-ui-react";
import { Title, Field, ButtonItem, InText, Segmant } from "../../components";
import { styles } from "./element";
// import { Button, Form, Input } from "formik-semantic-ui";
// import { Button } from "formik-semantic-ui";
class AuthBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      first_name: "",
      last_name: "",
      email: "",
      first_name_err_status: false,
      first_name_err_msg: "",
      last_name_err_status: false,
      last_name_err_msg: "",
      email_err_status: false,
      email_err_msg: "",
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.signupSubmit = this.signupSubmit.bind(this);
  }
  closeModal = () => {
    this.setState({
      open: false,
    });
  };
  handleFirstNameChange = (e) => {
    this.setState({
      first_name: e.target.value,
      first_name_err_status: false,
    });
  };
  handleLastNameChange = (e) => {
    this.setState({
      last_name: e.target.value,
      last_name_err_status: false,
    });
  };
  signupSubmit = (e) => {
    e.preventDefault();
    var flag = 1;
    const {
      first_name,
      last_name,
      first_name_err_status,
      first_name_err_msg,
      last_name_err_status,
      last_name_err_msg,
    } = this.state;
    if (first_name === "") {
      flag = 0;
      this.setState({
        first_name_err_status: true,
        first_name_err_msg: "First Name Required",
      });
    }
    if (first_name && first_name.length < 3) {
      flag = 0;
      this.setState({
        first_name_err_status: true,
        first_name_err_msg: "Minimum 3 characters",
      });
    }
    if (first_name && first_name.length > 15) {
      flag = 0;
      this.setState({
        first_name_err_status: true,
        first_name_err_msg: "Maximum 15 characters",
      });
    }
    if (last_name === "") {
      flag = 0;
      this.setState({
        last_name_err_status: true,
        last_name_err_msg: "Last Name Required",
      });
    }
    if (flag === 1) {
      var values = {
        id: "smodal",
        first_name: first_name,
        last_name: last_name,
        email: email,
      };
      localStorage.setItem("auth_query", JSON.stringify(values));
      Router.push(
        { pathname: "/RegMain", asPath: "/RegMain", query: values },
        "/RegMain",
      );
    }
  };
  render() {
    const validations = yup.object().shape({
      first_name: yup
        .string()
        .min(3, "Minimum 3 characters")
        .max(15, "Maximum 15 characters")
        .required("Name is required"),
      last_name: yup
        .string()
        .min(3, "Minimum 3 characters")
        .max(15, "Maximum 15 characters"),
      email: yup.string().email("Invalid Email").required("Email is required"),
    });
    const {
      first_name,
      last_name,
      first_name_err_status,
      first_name_err_msg,
      last_name_err_status,
      last_name_err_msg,
    } = this.state;
    return (
      <div>
        <Modal open={this.state.open} size="tiny" style={styles}>
          <Segment padded>
            <Grid>
              <Grid.Row>
                <Grid.Column width={14}>
                  <Title floated="left" content="Join RYLY" size="large" />
                </Grid.Column>
                <Grid.Column verticalAlign="middle" width={2}>
                  <span onClick={this.closeModal}>
                    <Icon link size="large" name="close" />
                  </span>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider hidden />
            <Modal.Content>
              <Form onSubmit={this.signupSubmit}>
                <Form.Group widths="equal">
                  <Form.Input
                    fluid
                    placeholder="First Name"
                    value={first_name}
                    onChange={this.handleFirstNameChange}
                    error={first_name_err_status}
                  />
                  <Form.Input
                    fluid
                    placeholder="Last Name"
                    value={last_name}
                    onChange={this.handleLastNameChange}
                    error={last_name_err_status}
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  {first_name_err_status ? (
                    <p style={{ color: "#c02e26" }}>{first_name_err_msg}</p>
                  ) : (
                    <p>&nbsp;</p>
                  )}
                  {last_name_err_status ? (
                    <p style={{ color: "#c02e26" }}>{last_name_err_msg}</p>
                  ) : (
                    <p>&nbsp;</p>
                  )}
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Input fluid placeholder="Email" />
                </Form.Group>
                <Button type="submit" content="Join" fluid primary />
              </Form>
              {/*<Form
								initialValues={{
									first_name: "",
					         			last_name: "",
								        email:"",
									id: "smodal"
								}}
								onSubmit={(values) => submit(values)}
								validationSchema={validations}
							>
								<Form.Group widths="2">
									<Input
										name="first_name"
										inputProps={{
											placeholder: "First Name"
										}}
									/>
									<Input
										name="last_name"
										inputProps={{
											placeholder: "Last Name"
										}}
									/>
								</Form.Group>
								<Input
									name="email"
									inputProps={{
										placeholder: "Email"
									}}
								/>
								<Divider hidden />
								<Button.Submit fluid primary>
		              Join
								</Button.Submit>
							</Form>*/}
              <Segmant>
                <span style={{ cursor: "pointer" }} onClick={(e) => next(e)}>
                  <InText
                    id="smodal"
                    content="Sign In"
                    floated="right"
                    color="blue"
                  />
                </span>
                <InText content="Already a Member ?" floated="right" />
              </Segmant>
              <Divider hidden />
              <Divider hidden />
              <InText
                textAlign="center"
                content="By joining you agree to RYLY's Terms of Use and Privacy Policy"
              />
            </Modal.Content>
          </Segment>
        </Modal>
      </div>
    );
  }
}

export default AuthBlock;
